import Actas from "../Actas";

const MisSolicitudes = () => {
  return <Actas />;
};

export default MisSolicitudes;
